import { connectRouter } from 'connected-react-router';
import { History } from 'history';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { CallState, ExtensionDevice, Media } from '../../model';
import { createWebRtcReducer } from 'webrtc-client-janus';
import callback from './callback';
import config, { selectMyDevices } from './config';
import agentStats from './agentStats';
import calls from './calls';
import command from './command';
import contacts from './contacts';
import emails from './emails';
import facebook from './facebook';
import instantMessager from './instantmessager';
import janusExtra from './janusExtra'
import localSettings from './localSettings';
import media, { selectMyActiveCall } from './media';
import mediaDrag from './mediaDrag';
import modals from './modals';
import { now, idleSeconds } from './now';
import outbounds from './outbound';
import queueAgents from './queueAgents';
import queueEmails from './queueEmails';
import queues from './queues';
import shortcuts from './shortcuts';
import squads from './squads';
import tasks from './tasks';
import toasts from './toasts';
import callTranscriptions from './transcriptions';
import twitter from './twitter';
import voiceMail from './voiceMail';
import wrapups from './wrapups';
import search from './search';
import settings from './settings';
import crmIntegration from './crmIntegration'

export function createRootReducer(history: History) {
  return combineReducers({
    janus: createWebRtcReducer(),
    janusExtra,
    router: connectRouter(history),
    config,
    callback,
    calls,
    command,
    emails,
    localSettings,
    media,
    now,
    idleSeconds,
    queueAgents,
    queues,
    voiceMail,
    wrapups,
    outbounds,
    facebook,
    tasks,
    squads,
    twitter,
    toasts,
    mediaDrag,
    queueEmails,
    instantMessager,
    contacts,
    callTranscriptions,
    shortcuts,
    modals,
    agentStats,
    search,
    settings,
    crmIntegration,
  })
}

export const selectActiveDevice = createSelector(
  selectMyActiveCall,
  selectMyDevices,
  (call, devices) => {
    if (!devices) { return null }
    if (!call) { return devices.primaryDevice }
    return getActiveDevice(call, devices.devices, devices.primaryDevice)
  },
)

export function getActiveDevice(call: Media, devices: ExtensionDevice[], priamary: ExtensionDevice) {
  let active: ExtensionDevice | undefined

  if (call.devices) {
    if (call.devices.length === 1) {
      // if one device in call then match it to one of our devices
      const { number } = call.devices[0]
      active = devices.filter(d => d.number === number)[0]
    } else {
      // if multiuple in call then match device to primary if it does
      active = call.devices.some(d => d.number === priamary.number) ? priamary : undefined
    }
  }

  if (!active) {
    // if no devices on call then match extension id to devices
    if (call.status === CallState.CallInVoicemail || call.status === CallState.QueueHold) {
      active = devices.filter(d => d.number === call.queueId)[0]
    } else {
      active = devices.filter(d => d.number === call.deviceId)[0]
    }
  }

  if (!active) {
    /*
    if (call.mediaType === "CALL") {
      console.error('No active device found, so returning primary: ' + priamary.number)
    }
    */
    active = priamary
  }

  return active
}
